<template>
  <span class="quantity-display">
    <span class="quantity-value">{{ formattedValue }}</span>
    <span class="quantity-unit" v-if="unit">{{ unit }}</span>
  </span>
</template>

<script>
/**
 * 任务C：数量+单位统一展示组件（全局注册——main.js）
 * 用法：<QuantityDisplay :value="scope.row.quantity" :unit="scope.row.unit" />
 */
export default {
  name: 'QuantityDisplay',
  props: {
    value: { type: [Number, String], default: null },
    unit: { type: String, default: '' },
    empty: { type: String, default: '-' }
  },
  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined || this.value === '') {
        return this.empty
      }
      const n = Number(this.value)
      if (isNaN(n)) return this.value
      // 整数去尾零，小数保留2位
      return Number.isInteger(n) ? n : n.toFixed(2)
    }
  }
}
</script>

<style scoped>
.quantity-display { display: inline-flex; align-items: baseline; gap: 4px; }
.quantity-unit { color: #909399; font-size: 12px; }
</style>
